document.addEventListener('DOMContentLoaded', () => {
    const mobileMediaQuery = window.matchMedia('(max-width: 991px)');
    const minSwipeDistance = 50;
    
    // Helper function to dynamically add the indicator bar
    function addIndicatorBar(wrapper) {
        if (wrapper.querySelector('.swipe-indicator-bar')) {
            return;
        }

        const indicatorBar = document.createElement('div');
        indicatorBar.classList.add('swipe-indicator-bar');

        const indicatorProgress = document.createElement('div');
        indicatorProgress.classList.add('swipe-indicator-progress');

        indicatorBar.appendChild(indicatorProgress);
        wrapper.appendChild(indicatorBar);
    }

    // --- Main Logic: Indicator aur Swipe functionality lagana ---
    function initializeSwipeFunctionality() {
        // Naye DOM se saare wrappers ko dobara select karein
        const wrappers = document.querySelectorAll('.card .card-product--image');
        
        if (wrappers.length === 0) return;

        wrappers.forEach(wrapper => {
            // Check karein ki is wrapper par functionality pehle se lagi hai ya nahi
            // Ye double-setup se bachne ke liye zaroori hai
            if (wrapper.dataset.swipeInitialized === 'true') {
                return;
            }

            // Agar mobile screen hai, toh indicator bar add karein
            if (mobileMediaQuery.matches) {
                addIndicatorBar(wrapper);
            }

            // Swipe Logic
            let touchStartX = 0;
            let touchEndX = 0;

            const handleSwipe = () => {
                const isRevealed = wrapper.classList.contains('reveal-active');
                const swipeDistance = touchEndX - touchStartX;

                // Swipe Left
                if (swipeDistance < -minSwipeDistance && !isRevealed) {
                    wrapper.classList.add('reveal-active');
                } 
                // Swipe Right
                else if (swipeDistance > minSwipeDistance && isRevealed) {
                    wrapper.classList.remove('reveal-active');
                }
                
                touchStartX = 0;
                touchEndX = 0;
            };

            wrapper.addEventListener('touchstart', (e) => {
                touchStartX = e.changedTouches[0].screenX;
            });

            wrapper.addEventListener('touchend', (e) => {
                touchEndX = e.changedTouches[0].screenX;
                handleSwipe();
            });

            // Is wrapper ko mark karein ki functionality lag chuki hai
            wrapper.dataset.swipeInitialized = 'true';
        });
    }

    // 1. Initial run jab page load ho
    initializeSwipeFunctionality();

    // 2. MutationObserver set up karein
    const gridContainer = document.getElementById('ProductGridContainer');

    if (gridContainer) {
        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
                // Agar children elements (products) remove/add hue hain
                if (mutation.type === 'childList') {
                    // Functionality ko dobara run karein taake naye products par lage
                    initializeSwipeFunctionality();
                    break; // Ek baar run karne ke baad loop se bahar aa jayein
                }
            }
        });

        // Observer ko grid container par lagayein taake iske andar hone wale changes ko track karein
        observer.observe(gridContainer, { childList: true, subtree: true });
    }

    // 3. Screen size change listener (Optional, jaisa pehle tha)
    mobileMediaQuery.addListener((e) => {
        if (e.matches) {
             // Agar mobile view mein aaya, har naye element par indicator lagao
             initializeSwipeFunctionality();
        } else {
             // Agar desktop view mein gaya, toh indicator remove kar dein
             document.querySelectorAll('.swipe-indicator-bar').forEach(indicator => indicator.remove());
        }
    });
});